module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2p",
    attrs: {
      "id": "part01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('span', {
    staticClass: "parts"
  }, [_vm._v("Part One")]), _c('br'), _c('strong', [_vm._v("Fundamentals of Servant Leadership")])])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Descriptions of Basic Aspects of Servant Leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "bull-lista"
  }, [_vm._v("•   Ken Blanchard covers his leadership philosophy in “What Is Servant Leadership?” by emphasizing the two parts of servant leadership: the "), _c('em', [_vm._v("leadership/strategic")]), _vm._v(" aspect and the "), _c('em', [_vm._v("servant/operational")]), _vm._v(" aspect.")]), _vm._v(" "), _c('p', {
    staticClass: "bull-lista"
  }, [_vm._v("•   Larry C. Spears, inspired by his mentor and pioneer in the field of servant leadership Robert K. Greenleaf, discusses “Characteristics of Servant Leaders.”")]), _vm._v(" "), _c('p', {
    staticClass: "bull-lista"
  }, [_vm._v("•   Raj Sisodia, cofounder of the Conscious Capitalism movement, shows in “Servant Leadership Is Conscious Leadership” how the qualities of "), _c('em', [_vm._v("servant")]), _vm._v(" leaders overlap considerably with those of "), _c('em', [_vm._v("conscious")]), _vm._v(" leaders.")]), _vm._v(" "), _c('p', {
    staticClass: "bull-lista"
  }, [_vm._v("•   Stephen M. R. Covey, in “Servant Leadership at the Speed of Trust,” reflects on how trust is inextricably linked to the practice of servant leadership.")]), _vm._v(" "), _c('p', {
    staticClass: "bull-lista"
  }, [_vm._v("•   Mark Miller, in “Great Leaders SERVE,” relates how the SERVE acronym developed at Chick-fil-A can help you become a servant leader.")]), _vm._v(" "), _c('p', {
    staticClass: "bull-lista"
  }, [_vm._v("•   Mark A. Floyd offers advice to new servant leaders in his essay “Servant Leadership: What Does It Really Mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "bull-lista"
  }, [_vm._v("•   Michael C. Bush, CEO of Great Places to Work For All, shows that the most extraordinary organizations are led by servant leaders in “Servant Leaders Create a Great Place to Work for All.”")])]), _c('p', {
    staticClass: "bull-lista"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("•   Holly Culhane, in “The Leader as Shepherd,” presents a compelling argument that the shepherd is one of the best examples of a servant leader.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "bull-lista"
  }, [_vm._v("•   Simon Sinek, in “The Evolution of Servant Leadership,” shares his thoughts about the roots of servant leadership—and why it matters.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2b3892","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01.vue
// module id = 87
// module chunks = 0